import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "🛋️", key: "livingRoom" },
  { emoji: "🛏️", key: "bedroom" },
  { emoji: "🍳", key: "kitchen" },
  { emoji: "💼", key: "homeOffice" },
  { emoji: "🏠", key: "multipleRooms" },
]

export default function HomeRoomFocusPage() {
  return <RadioCardListPage translationKey="homeRoomFocus" options={OPTIONS} />
}
